import { Beginner } from '../components/Icons/ExperiencieBadget/Beginner';
import { Pro } from '../components/Icons/ExperiencieBadget/Pro';

export const experiencieBagdetView = (exp: number) => {
	switch (exp) {
		case 0:
			return <Beginner style="w-8 h-8" />;
		case 1:
			return <Pro style="w-8 h-8" />;
		default:
			<></>;
	}
};

export const experiencieBagdetProfileView = (exp: number) => {
	switch (exp) {
		case 0:
			return <Beginner style="w-10 h-10" />;
		case 1:
			return <Pro style="w-10 h-10" />;
		default:
			<></>;
	}
};

export const experiencieBagdetTableView = (exp: number) => {
	switch (exp) {
		case 0:
			return <Beginner style="w-4 h-4" />;
		case 1:
			return <Pro style="w-4 h-4" />;
		default:
			<></>;
	}
};

export const experiencieBagdetFeedView = (exp: number) => {
	switch (exp) {
		case 0:
			return <Beginner style="w-6 h-6" />;
		case 1:
			return <Pro style="w-6 h-6" />;
		default:
			<></>;
	}
};

export const experiencieBagdetName = (exp: number) => {
	switch (exp) {
		case 0:
			return 'Novato';
		case 1:
			return 'Profissional';
		default:
			return 'Novato';
	}
};
